import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	displayText: {
		id: 'software.main.header.menu.create-board.display-text',
		defaultMessage: 'Create board',
		description: 'Dropdown menu item which open the "create board" feature',
	},
});
